import React, { Component } from 'react';
import './AppNavigation.css';
import navigateBackIco from '../img/navigateBack.png';

class AppNavigation extends Component {
    render() {

        const isHavePreviousStep = this.props.previousStep;
        let backNavigation;
        if (this.props.backNavigation === false) {
            backNavigation = 'hideBackButton';
        }
        return (
            <div className="appNavigation col-xs-12" id={backNavigation}>
                <div>
                        <div className="col-xs-2">
                            { isHavePreviousStep ? (
                                <div className='navigationBackButton' onClick={this.props.previousStep}><img src={navigateBackIco} alt="navigationBackButton" /></div>
                            ) : (
                                <div className='navigationBackButton hiddenButton'><img src={navigateBackIco} alt="navigationBackButton" /></div>
                            )}
                        </div>
                        <div className="col-xs-10">
                            <span className="navigationName">{this.props.stepName}<span className="navigationNumber">0{this.props.stepNumber}</span></span>
                        </div>
                </div>
            </div>
        );
    }
}

export default AppNavigation;



// WEBPACK FOOTER //
// ./src/components/AppNavigation.jsx